import {
    GET_LIST_UNIT,
    UPDATE_SPECIFIC_UNIT,
    CREATE_NEW_UNIT,
    REMOVE_UNIT,
    GET_UNIT_ACTIVE
} from '../actions/types';

/**
 * initial state
 */
const INIT_STATE = {
    unit_list: [],
    unit_active_list: [],
    pagination: {
        currentPage: 1,
        total: 0, // total records
        perPage: 30
    }
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case GET_LIST_UNIT: {
            return {
                ...state,
                unit_list: action.payload?.data || [],
                pagination: {
                    currentPage: parseInt(action.payload.current_page),
                    total: parseInt(action.payload.total),
                    perPage: parseInt(action.payload.per_page),
                }
            }
        }
        case GET_UNIT_ACTIVE: {
            return {
                ...state,
                unit_active_list: action.payload.data,
            }
        }
        case CREATE_NEW_UNIT: {
            return {
                ...state,
                unit_list: [action.payload, ...state.unit_list],
                total: state.total + 1
            }
        }
        case UPDATE_SPECIFIC_UNIT: {
            let index = state.unit_list.findIndex((item) => {
                return item.id == action.payload.id;
            });
            let temp = [...state.unit_list];
            temp[index] = action.payload;
            return { ...state, unit_list: temp }
        }
        case REMOVE_UNIT: {
            let temp = state.unit_list.filter(item => {
                return action.payload.indexOf(item.id) < 0;
            });
            return { ...state, unit_list: temp }
        }
        default: return { ...state };
    }
}
